export const deleteAPost = (id) => ({ type: 'DELETE_A_POST', id });




// WEBPACK FOOTER //
// ./src/actions/postActions.js